import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./notifications.sass";
import {
    BadgeCustom,
    ParagraphCustom,
    MenusCustomPro,
    MenusItemsCustomPro,
    AvatarCustom,
    DropdownCustom,
} from "../../../../../custom";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { NotificationsType } from "../../../../../../constants/enums";
import { LangContext } from "../../../../../../hooks/context/lang";
import { showNotification } from "../../../../../../utils/notificationsGeneric";
import { LinkActiveContext } from "../../../../../../hooks/context/linkActive";
import { NotResults } from "../../../../../noResultGeneric/notResults";

import { RestApiClientContext } from "../../../../../../hooks/context/pageContext";

// Componente Notificaciones para la cabecera de la página
export const Notifications = () => {
    const restApiClient = useContext(RestApiClientContext);

    const linkActive = useContext(LinkActiveContext);

    // Libreria i18n para traducir
    const { t } = useTranslation(["notifications", "translation", "urls"]);

    // Contexto con el idioma del usuario
    const language = useContext(LangContext);
    const userLang = language.GetLangContext();

    const [notifications, setNotifications] = useState<any[]>([]);
    const [messageApi, setMessageApi] = useState<string>("");

    useEffect(() => {
        restApiClient.getNotifications(userLang)
            .then((data) => {
                if (data) {
                    setNotifications(data);
                } else {
                    setNotifications([]);
                    setMessageApi("not-result");
                }
            })
    }, []);

    // Construye el string con el tiempo transcurrido de la notificación
    const getTimeElapsedText = (timeElapsed) =>
        t(
            timeElapsed.time === 1
                ? "time." + timeElapsed.type + "-ago"
                : "time." + timeElapsed.type + "-s-ago",
            { 0: timeElapsed.time }
        );

    const menu = (
        <MenusCustomPro className="content-list-items-notifications">
            {notifications.length > 0 ? (
                notifications.map((e, i) => {
                    return (
                        <MenusItemsCustomPro
                            className="content-line-break"
                            key={i}
                        >
                            <Link
                                className="link-list height-box-notification"
                                to={
                                    e.notificationType ===
                                        NotificationsType.Agent
                                        ? t("urls:private.agents-register")
                                        : t("urls:private.regularization")
                                }
                                onClick={() =>
                                    linkActive.updateValueUrl(
                                        e.notificationType ===
                                            NotificationsType.Agent
                                            ? t("urls:private.agents-register")
                                            : t("urls:private.regularization")
                                    )
                                }
                            >
                                <div className="content-avatar-list">
                                    <AvatarCustom
                                        classAvatar={"avatar-list-agents"}
                                        // avatar={e.notificationData.avatar} // TODO: Mientras no tengamos imágenes buenas, se queda así
                                        avatar={
                                            e.notificationType ===
                                                NotificationsType.Agent
                                                ? "https://rewards-cdn-dev.beds2b.es/public/images/defaults/agent.png"
                                                : "https://rewards-cdn-dev.beds2b.es/public/images/defaults/booking.png"
                                        }
                                    />
                                </div>
                                <div>
                                    <ParagraphCustom
                                        class="size-notif"
                                        text={e.message}
                                    />
                                    <ParagraphCustom
                                        class="m-0 size-notif text-time"
                                        text={getTimeElapsedText(e.timeElapsed)}
                                    />
                                </div>
                            </Link>
                        </MenusItemsCustomPro>
                    );
                })
            ) : (
                    <NotResults section={"notification"} messageApi={messageApi} />
                )}
        </MenusCustomPro>
    );

    return (
        <DropdownCustom overlay={menu}>
            <div>
                <BadgeCustom
                    count={notifications.length}
                    icon={faBell}
                    classIcon="icons-color-menu icons-color-marging secondary-links-svg color-bell"
                />
            </div>
        </DropdownCustom>
    );
};
